import { LEVEL_STYLES } from 'utils/Utils'

export default function LevelCircle({ slug, textClass = 'text-xl w-8 h-8' }) {
    return (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center' }} className={`text-center ${textClass} font-bold ml-[-5px] rounded-full flex items-center justify-center border-2 border-white ${LEVEL_STYLES[slug]?.badge}`}>
            {slug?.charAt(0)?.toUpperCase()}
        </div>
    )
}
